import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_ALL_STORIES = gql`
  query GetAllStories($clientID: String) {
    stories(clientID: $clientID) {
      entries {
        id
        title
        portrait
        bicID
        quizDone
        gradient
        icon {
          iconValue
          color
        }
        color
        user {
          avatar {
            ...imageFields
          }
          position
        }
        image {
          ...imageFields
        }
        cards {
          image {
            ...imageFields
          }
          layout
          highlightPosition
#          imagePosition
          backgroundVideo {
            title
            author
            authorUrl
            thumbnailUrl
            thumbnailHeight
            thumbnailWidth
            src
          }
          backgroundImage {
            ...imageFields
          }
          textHeading
          text
          time
          title
          embedVideo {
            title
            author
            authorUrl
            thumbnailUrl
            thumbnailHeight
            thumbnailWidth
            src
          }
          lottieAnimation
          theme
        }
        nextStories {
          title
          description
          stories {
            avatar {
              ...imageFields
            }
            title
            linkTitle
            storyId
          }
        }
        vrDirectLink
        quizLink
        jobName
        schoolProfile {
          uuid
        }
      }
    }
  }
  ${ImageFragment}
`;
